import {ReservationStatus} from "crqlar-react-common/dist/models/reservation/reservation.model";
import type {SurveyDailyListRow} from "crqlar-react-common/dist/models/survey/surveyDailyList.model";
import {formatSurveyScore} from "../../common/uiElements/SurveyScoreElement";

/**
 * Cancelled and no-show stays are listed for completeness, as on the CRM daily list, but nobody was
 * in house to ask: they are never offered a link and do not count towards a group's invitations.
 * A group carries a status only when all its rooms share it.
 */
export const isCancelledStay = (row: SurveyDailyListRow) => (
    row.reservationStatus === ReservationStatus.CANCELLED || row.reservationStatus === ReservationStatus.NO_SHOW
);

/** A room row's own room, or every room of a group. */
export const roomNames = (row: SurveyDailyListRow) => (
    row.accommodationResources?.map(resource => resource.name).filter(Boolean).join(', ') ?? ''
);

export const formatSurveyDailyScore = (score?: number | null) => (score == null ? '—' : formatSurveyScore(score));
